module.exports = __webpack_public_path__ + "img/fuzion-img-1.daf70da7.jpg";